import { FC } from "react";
import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import OrderDetailsHeaderWeb from "./layouts/OrderDetailsHeader.web";
import OrderDetailsHeaderMob from "./layouts/OrderDetailsHeader.mob";

const OrderDetailsHeaderComponent = withConditionalComponent(OrderDetailsHeaderWeb, OrderDetailsHeaderMob);

type Props = {
  label?: string;
};

const OrderDetailsHeader: FC<Props> = ({ label }) => {
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <OrderDetailsHeaderComponent trigger={isLargeScreen} props={{ label }} />;
};

export default OrderDetailsHeader;
